import $ from 'jquery'
import ChartHierarchicalSelectorsSectionStrategy from './ChartHierarchicalSelectorsSectionStrategy'
import {Errors} from './constants'

function LeaveHierarchicalSelectorsSectionStrategy({showUserSelector, balanceUserSelector}) {
    this.params = {
        showUserSelector,
        balanceUserSelector,
    }
}

LeaveHierarchicalSelectorsSectionStrategy.prototype = new ChartHierarchicalSelectorsSectionStrategy();

LeaveHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function() {
    ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI.call(this)
    let classes = this.params.showUserSelector ?
                  this.getVisibleBalanceUsersSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName() :
                  " " + this.getVisibleUsernameClassName()
    classes += " " + this.getVisibleLeaveTypesSelectorClassName()
    $(this.container).addClass(classes)
}

LeaveHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function() {
    return this.params.showUserSelector
}

LeaveHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function() {
    return this.params.balanceUserSelector.getSelection()
}

LeaveHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function()
{
    return {
        userSelection: this.params.balanceUserSelector.getSelection(),
        leaveTypeSelection: this.leaveTypesSelector.getLeaveTypeSelection()
    };
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.validate = function()
{
    const errors = [];

    if ( !this.validateIsUserSelected() )
        errors.push( Errors.ERROR_EMPTY_BALANCE_USER_SELECTION );
    if ( this.leaveTypesSelector.isEmptySelection() )
        errors.push( Errors.ERROR_EMPTY_LEAVE_TYPES_SELECTION );

    return errors;
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function() {
    return this.params.balanceUserSelector.validateIsUserSelected()
}

LeaveHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function(selection) {
    this.params.balanceUserSelector.setSelection(selection)
}

export default LeaveHierarchicalSelectorsSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/LeaveHierarchicalSelectorsSectionStrategy.js